module.exports = __webpack_public_path__ + "static/media/rosette.f83d1c54.svg";